import { reduxActions } from '../constants';

export default class FAQActions {
    static addFaq(faq) {
        const key = Array.isArray(faq) ? 'faqs' : 'faq';

        let action = {
            type: reduxActions.ADD_FAQ_ITEM
        }
        action[key] = faq;

        return action;
    }

    static resetFAQ() {
        return {
            type: reduxActions.RESET_FAQ
        }
    }
}



// WEBPACK FOOTER //
// ./web-app/actions/faq-actions.js